module.exports = require('./lib/reading-time');



//////////////////
// WEBPACK FOOTER
// ./~/reading-time/index.js
// module id = 74
// module chunks = 30862416422887 221374088121123